import { SupplyInvoiceReceptionLayout } from '../../../models/fisso';

export const textField = {
  sameTypeAddress: (
    address: string,
    modifiedAsset: string,
    isEmail2Email: boolean,
    oldLayout: SupplyInvoiceReceptionLayout,
    newLayout: SupplyInvoiceReceptionLayout
  ) => {
    const assetList = buildAssetListString(modifiedAsset);
    return `Il Cliente sottoscrivendo il presente modulo, tramite firma elettronica semplice (FES), richiede che venga modificato l’indirizzo di posta ${
      isEmail2Email ? 'elettronica' : 'cartacea'
    } oggi presente per la ricezione fatture in relazione alle seguenti forniture:
    <br><br>
    ${assetList}
    <br><br>
    con il nuovo indirizzo ${address}
    ${
      oldLayout !== newLayout && oldLayout && newLayout
        ? `<br/><br/>e richiede altresì che le Bollette gli siano inviate nel formato bolletta sintetica${
            newLayout === SupplyInvoiceReceptionLayout.analitica ? ' e di dettaglio' : ''
          }.`
        : ''
    }
    <br><br>
    La modifica sarà effettuata a partire dalla prima fattura utile.
    <br><br>
    Per tutto quanto non modificato con la presente, restano validi i consensi e le ulteriori informazioni fornite all'interno del modulo di Adesione alla Proposta di fornitura in fase di sottoscrizione iniziale del contratto, o come modificate in vigenza di contratto.<br>
    <strong>In particolare, si ricorda che resta invariato l’indirizzo di ricezione documenti per tutte le forniture contrattualizzate con Alleanza luce & gas nonché l’indirizzo di ricezione fatture in relazione alle eventuali altre forniture contrattualizzate con Alleanza luce & gas non citate nel presente modulo.</strong>
    <br><br>
    Puoi sempre visionare l’informativa privacy completa disponibile su <a href="https://www.accendilucegas.it/privacy-policy" target="_blank">www.accendilucegas.it/privacy-policy</a>`;
  },
  changeTypeAddress: (
    address: string,
    modifiedAsset: string,
    isEmail2Physical: boolean,
    oldLayout: SupplyInvoiceReceptionLayout,
    newLayout: SupplyInvoiceReceptionLayout
  ) => {
    const assetList = buildAssetListString(modifiedAsset);
    return `${
      isEmail2Physical
        ? 'Il Cliente sottoscrivendo il presente modulo, tramite firma elettronica semplice (FES), richiede l’eliminazione dell’indirizzo di posta elettronica oggi presente per la ricezione fatture e la conseguente modifica della modalità di ricezione fatture in relazione alle seguenti forniture'
        : 'Il Cliente sottoscrivendo il presente modulo, tramite firma elettronica semplice (FES), richiede la modifica della modalità ricezione fatture da posta cartacea a posta elettronica in relazione alle seguenti forniture:'
    }
    <br><br>
    ${assetList}
    <br><br>
    ${isEmail2Physical ? "da posta elettronica a posta cartacea all'indirizzo " : 'all’indirizzo di posta elettronica '} ${address}
    ${
      oldLayout !== newLayout && oldLayout && newLayout
        ? `<br/><br/>e richiede altresì che le Bollette gli siano inviate nel formato bolletta sintetica${
            newLayout === SupplyInvoiceReceptionLayout.analitica ? ' e di dettaglio' : ''
          }.`
        : ''
    }
    <br><br>
    La modifica sarà effettuata a partire dalla prima fattura utile.
    <br><br>
    Per tutto quanto non modificato con la presente, restano validi i consensi e le ulteriori informazioni fornite all'interno del modulo di Adesione alla Proposta di fornitura in fase di sottoscrizione iniziale del contratto, o come modificate in vigenza di contratto.<br>
    <strong>In particolare, si ricorda che resta invariato l’indirizzo di ricezione documenti per tutte le forniture contrattualizzate con Alleanza luce & gas nonché l’indirizzo di ricezione fatture in relazione alle eventuali altre forniture contrattualizzate con Alleanza luce & gas non citate nel presente modulo.</strong>
    <br><br>
    Puoi sempre visionare l’informativa privacy completa disponibile su <a href="https://www.accendilucegas.it/privacy-policy" target="_blank">www.accendilucegas.it/privacy-policy</a>.`;
  },
  changeLayout: (modifiedAsset: string, newLayout: SupplyInvoiceReceptionLayout) => {
    const assetList = buildAssetListString(modifiedAsset);
    return `Il Cliente sottoscrivendo il presente modulo, tramite firma elettronica semplice (FES), richiede di poter ricevere le Bollette in formato bolletta sintetica${
      newLayout === SupplyInvoiceReceptionLayout.analitica ? ' e di dettaglio' : ''
    } in relazione alle seguenti forniture:
    <br><br>
    ${assetList}
    <br><br>
    La modifica sarà effettuata a partire dalla prima fattura utile.`;
  },
};

const buildAssetListString = (modifiedAsset: string) => {
  let assetList = null;
  if (modifiedAsset && modifiedAsset.trim()) {
    if (modifiedAsset.endsWith(';')) {
      modifiedAsset = modifiedAsset.slice(0, -1);
    }
    const assetArray = modifiedAsset.split(';');
    if (assetArray && assetArray.length > 0) {
      assetList = assetArray.map((num) => `nr fornitura: ${num.trim()}`).join('<br>');
    }
  }
  return assetList;
};



// WEBPACK FOOTER //
// ./src/app/components/alg-supply-invoice-reception-management/alg-supply-invoice-reception-info-subscription/supply-invoice-reception-conditions-subscriptions.ts